import { TRANSFER_APPROVAL } from '../actionTypes';

const initialState = {
  transferRules: [],
  transferRulesTotalElements: 0,
  teamMembers: [],
  existingRuleDetails: {
    rule: { label: '', value: '' },
    amount: 0,
    approval: false,
    approvedMembers: [],
  },
  status: {
    message: null,
    type: null,
    value: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_APPROVAL.SET_TRANSFER_RULES:
      return {
        ...state,
        transferRules: action.payload,
      };
    case TRANSFER_APPROVAL.SET_TRANSFER_RULES_TOTAL_ELEMENTS:
      return {
        ...state,
        transferRulesTotalElements: action.payload,
      };
    case TRANSFER_APPROVAL.SET_TEAM_MEMBERS:
      return {
        ...state,
        teamMembers: action.payload,
      };
    case TRANSFER_APPROVAL.SET_STATUS:
      return {
        ...state,
        status: {
          message: action.payload.message,
          type: action.payload.type,
          value: action.payload.value,
        },
      };
    case TRANSFER_APPROVAL.SET_EXISTING_RULE:
      return {
        ...state,
        existingRuleDetails: {
          rule: action.payload.rule,
          amount: action.payload.amount,
          approval: action.payload.approval,
          approvedMembers: action.payload.approvedMembers,
        },
      };
    default:
      return state;
  }
};
